
<template>
  <v-app id="searchKlav">
    <v-main>
    <v-container fluid>  
    <v-card>
      <v-card-title>Guest cancellation terms</v-card-title>
      <v-simple-table dense>
         <tbody v-for="(klavRecord,i) in searchKlav" :key="i">
           <tr @click="$router.reload('/syst/ref/klav/onKlav/' + klavRecord.klav_encrid)">
             <td>{{klavRecord.klav_nr}}</td>
             <td>{{klavRecord.klav_oms}}</td>
           </tr>  
         </tbody>  
       </v-simple-table>  
    </v-card>  
    </v-container>
    </v-main>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/> 
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  data() {
    return {
      searchKlav: []
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/syst/ref/klav/searchKlav.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchKlav"
          },
          searchKlav: {
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.searchKlav = res.data.searchKlav;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
};

</script> 
